import React from "react";
import { MenuItem } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import ActionDropdownButton from "./ActionDropdownButton";
import { intlShape } from "../../shapes";

type OwnProps = {
  handleSortClick?: $TSFixMeFunction;
  intl: intlShape;
  sortOptions?: string[];
  isOptionDisabled?: boolean;
  defaultCounter?: number;
  defaultOption?: string;
};

const defaultProps: Partial<OwnProps> = {
  handleSortClick: undefined,
  sortOptions: [],
  isOptionDisabled: false,
  defaultCounter: 0,
  defaultOption: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function SortActionDropdownButton({
  handleSortClick,
  sortOptions,
  isOptionDisabled,
  intl,
  defaultCounter,
  defaultOption,
}: Props) {
  const [state, setState] = React.useState({
    sortOption: defaultOption,
    sortClickCounter: defaultCounter,
    sorting: false,
  });

  React.useEffect(() => {
    const { sorting, sortOption, sortClickCounter } = state;
    if (sorting) {
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      handleSortClick(sortOption, sortClickCounter);
      setState({ ...state, sorting: false });
    }
  }, [state]);

  const setSortIcon = () => {
    switch (state.sortClickCounter) {
      case 1:
        return <span className="lineicon lcm-iot-icon-long-arrow-down" />;
      case 2:
        return <span className="lineicon lcm-iot-icon-long-arrow-up" />;
      default:
        return null;
    }
  };

  const handleSortOptionSelect = (item: $TSFixMe) => {
    let sortClickCounterValue;
    let selectedItem;
    if (state.sortOption === item && state.sortClickCounter === 2) {
      sortClickCounterValue = 0;
      selectedItem = undefined;
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    } else if (state.sortOption === item && state.sortClickCounter < 2) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const counter = state.sortClickCounter + 1;
      sortClickCounterValue = counter;
      selectedItem = item;
    } else {
      sortClickCounterValue = 1;
      selectedItem = item;
    }
    setState({
      sorting: true,
      sortOption: selectedItem,
      sortClickCounter: sortClickCounterValue,
    });
  };

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const renderSortItems = sortOptions.map((item) => (
    <MenuItem
      className={
        item === state.sortOption
          ? "dropdown-sort option-selected"
          : "dropdown-sort"
      }
      key={item}
      eventKey="sorting_content"
      id={"sorting-".concat(item).concat("-menu-item")}
      disabled={isOptionDisabled}
      onSelect={() => {
        handleSortOptionSelect(item);
      }}
    >
      <span className="dropdown-sort-label">
        <FormattedMessage id={"label.".concat(item)} />
      </span>
      {item === state.sortOption ? setSortIcon() : null}
    </MenuItem>
  ));

  return (
    <ActionDropdownButton
      // @ts-expect-error TS(2322) FIXME: Type '{ children: Element[]; id: string; icon: str... Remove this comment to see the full error message
      id="sorting-button"
      icon="icon2-eh-sort"
      title={intl.formatMessage({ id: "label.sort" })}
    >
      {renderSortItems}
    </ActionDropdownButton>
  );
}

SortActionDropdownButton.defaultProps = defaultProps;

export default injectIntl(SortActionDropdownButton);
